<h3>Logging you in...</h3>
<p>If you are not automatically redirected to the app, please click <a [routerLink]="['/']">here</a></p>